import { useRouter } from 'next/router';

import { Box, FormField, Label, Select } from '@zillow/constellation-10';

import { useScreenSize } from '../../../hooks';
import { useGetListingDetails } from '../../../hooks/queries/properties';
import { useFieldSave } from '../../../hooks/useFieldSave';
import { useMultiEditMutation } from '../../../hooks/useMultiEditMutation';

const PETS_OPTIONS = [
  { label: 'Select option', value: '' },
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3+', value: '3+' },
];

const CurrentPetsFormField = () => {
  const router = useRouter();
  const { isScreenDesktop } = useScreenSize();

  const listingAlias = router.query.listingAlias as string;
  const { data: listingDetails } = useGetListingDetails(listingAlias);

  // Note: API returns these as strings like "0", "1", "2", "3+"
  const currentCatsCount = listingDetails?.roomForRent?.currentPets?.currentCatsCount;
  const currentDogsCount = listingDetails?.roomForRent?.currentPets?.currentDogsCount;

  const updateMutation = useMultiEditMutation();

  const catsField = useFieldSave({
    fieldName: 'currentCatsCount',
    initialValue: currentCatsCount !== undefined ? String(currentCatsCount) : null,
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      postData: {
        property: { listingAlias, roomForRent: { currentCatsCount: String(value) } },
      },
    }),
    autoSaveOnChange: true,
  });

  const dogsField = useFieldSave({
    fieldName: 'currentDogsCount',
    initialValue: currentDogsCount !== undefined ? String(currentDogsCount) : null,
    mutation: updateMutation,
    buildMutationVariables: (value) => ({
      postData: { property: { listingAlias, roomForRent: { currentDogsCount: String(value) } } },
    }),
    autoSaveOnChange: true,
  });

  return (
    <Box data-testid="CurrentPetsFormField">
      <FormField
        label={<Label>Cats</Label>}
        control={
          <Select
            size={isScreenDesktop ? 'lg' : 'md'}
            name="currentCatsCount"
            value={catsField.value === null ? '' : String(catsField.value)}
            onChange={(e) => catsField.onChange(String(e.target.value))}
            required={false}
          >
            {PETS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              );
            })}
          </Select>
        }
      />

      <FormField
        label={<Label>Dogs</Label>}
        control={
          <Select
            size={isScreenDesktop ? 'lg' : 'md'}
            name="currentDogsCount"
            value={dogsField.value === null ? '' : String(dogsField.value)}
            onChange={(e) => dogsField.onChange(String(e.target.value))}
            required={false}
          >
            {PETS_OPTIONS.map(({ label, value }) => {
              return (
                <option key={value} value={value}>
                  {label}
                </option>
              );
            })}
          </Select>
        }
      />
    </Box>
  );
};

export default CurrentPetsFormField;
